import React, { useState } from "react"
import { SignInModal, TenantLogo, UserMenu, Button, ModerationIndicator, Avatar } from "@fider/components"
import { useFider } from "@fider/hooks"
import { HStack } from "./layout"
import { Trans } from "@lingui/react/macro"
import "./Header.scss"

interface HeaderProps {
  hasInert?: boolean
}

export const Header = (props: HeaderProps) => {
  const fider = useFider()
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false)

  const pathname = typeof window !== "undefined" ? window.location.pathname : "/"
  const isRoadmapActive = pathname === "/roadmap"
  const isInAppFeedbackActive = pathname.startsWith("/inapp-feedback")
  const isFeedbackActive = !isRoadmapActive && !isInAppFeedbackActive
  const showInAppFeedback = fider.session.isAuthenticated && fider.session.user.isCollaborator
  const showProfileMenu = fider.session.isAuthenticated && fider.session.user.isCollaborator

  const handleSignInClick = () => {
    setIsSignInModalOpen(true)
  }

  const hideSignInModal = () => setIsSignInModalOpen(false)

  return (
    <div id="c-header" {...(props.hasInert && { inert: "true" })}>
      <SignInModal isOpen={isSignInModalOpen} onClose={hideSignInModal} />
      <HStack className="c-menu p-4 w-full">
        <div className="container c-header__container">
          <div className="c-header__row">
            <a href="/" className="c-header__brand flex flex-x flex-items-center flex--spacing-2 h-8">
              <TenantLogo size={100} />
              <h1 className="text-header">{fider.session.tenant.name}</h1>
            </a>
            <HStack spacing={4} className="c-header__nav flex-items-center">
              <a href="/" className={`c-header__nav-link ${isFeedbackActive ? "c-header__nav-link--active" : ""}`}>
                <Trans id="header.nav.feedback">All Feedback</Trans>
              </a>
              <a href="/roadmap" className={`c-header__nav-link ${isRoadmapActive ? "c-header__nav-link--active" : ""}`}>
                <Trans id="header.nav.roadmap">Roadmap</Trans>
              </a>
              {showInAppFeedback && (
                <a href="/inapp-feedback" className={`c-header__nav-link ${isInAppFeedbackActive ? "c-header__nav-link--active" : ""}`}>
                  <Trans id="header.nav.inappfeedback">In-App Feedback</Trans>
                </a>
              )}
            </HStack>
            {fider.session.isAuthenticated && (
              <div className="c-header__moderation">
                <ModerationIndicator />
              </div>
            )}
            {fider.session.isAuthenticated && (
              <HStack spacing={2} className="c-header__actions">
                {showProfileMenu ? (
                  <UserMenu />
                ) : (
                  <div className="c-header__avatar" aria-hidden="true">
                    <Avatar user={fider.session.user} />
                  </div>
                )}
              </HStack>
            )}
            {!fider.session.isAuthenticated && (
              <HStack spacing={2} className="c-header__actions">
                <Button variant="primary" size="default" onClick={handleSignInClick}>
                  <HStack spacing={1} className="flex-items-center">
                    <span>
                      <Trans id="action.signin">Sign in</Trans>
                    </span>
                  </HStack>
                </Button>
              </HStack>
            )}
          </div>
        </div>
      </HStack>
    </div>
  )
}
